module.exports = __webpack_public_path__ + "img/packaging@2x.7910cc9.jpg";